import { Pipe, PipeTransform } from '@angular/core';
import { MomentDatePipe } from '@affinite/common';

@Pipe({
    name: 'dateFormatter',
    standalone: false
})
export class DateFormatterPipeComponent implements PipeTransform {
  constructor (private datePipe: MomentDatePipe){};

  transform(value: any, keyName: string, ...args: unknown[]): unknown {
    const format = args[0] as string;
    const timezone = args[1] as string;
    if (format != undefined) {
      return this.datePipe.transform(value, format, timezone);
    }
    else {
      return value;
    }  
  }
}
